import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getLead } from '../leadManagement/api/leadService';
import LeadSummary from '../leadManagement/components/LeadSummary';
import { useWorkspace } from '../integrationQA/context/WorkspaceContext';
import './lead-profile.css';

/**
 * Lead profile for the conversation being handled: the same facts Lead Management shows, so an agent
 * sees who they are talking to, how warm the lead is and what they asked for without switching screens.
 */
export default function LeadProfilePanel({ conversation }) {
  const { can } = useWorkspace();
  const allowed = can('leads:manage');
  const leadId = conversation && conversation.leadId;
  const [state, setState] = useState('idle'); // idle | loading | ready | missing | error
  const [lead, setLead] = useState(null);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    if (!allowed || !leadId) { setState('idle'); setLead(null); return undefined; }
    let active = true;
    setState('loading');
    getLead(leadId)
      .then((found) => { if (!active) return; setLead(found); setState(found ? 'ready' : 'missing'); })
      .catch(() => { if (active) setState('error'); });
    return () => { active = false; };
  }, [allowed, leadId, nonce]);

  if (!conversation) return null;
  return (
    <section className="aw-lead-profile" aria-label="Lead profile">
      <div className="aw-lead-head"><h4>Lead profile</h4>{state === 'ready' && can('leads:manage') && <Link to="/leads">Open Lead Management</Link>}</div>
      {!allowed && <p className="aw-lead-empty">Lead details are only visible to roles that manage leads.</p>}
      {allowed && !leadId && (
        <p className="aw-lead-empty">
          No lead captured yet. {conversation.visitorEmail
            ? 'The visitor gave an email but has not saved their details in the chat form.'
            : 'The visitor has not shared contact details. Ask for them in your reply; the chat widget has a “Share your contact details” form.'}
        </p>
      )}
      {allowed && leadId && state === 'loading' && <p className="aw-lead-empty" role="status">Loading lead…</p>}
      {allowed && leadId && state === 'missing' && <p className="aw-lead-empty">This lead was deleted from Lead Management.</p>}
      {allowed && leadId && state === 'error' && <p className="aw-lead-empty" role="alert">Could not load the lead. <button type="button" className="btn btn-link btn-sm p-0" onClick={() => setNonce((n) => n + 1)}>Retry</button></p>}
      {state === 'ready' && lead && <LeadSummary lead={lead} />}
    </section>
  );
}
